import styled, { css } from "styled-components/macro";

const PrimaryButton = styled.button.attrs({ type: "submit" })`
  border: 1px solid transparent;
  color: white;
  min-width: 100px;
  border-radius: 8px;
  padding: 0.5em 1em;
  text-decoration: none;
  font-size: 11px;
  min-width: 100px;
  font-family: "JioType-Medium";
  transition: all 0.3s ease;
  ${({ disabled }) =>
    disabled
      ? css`
          opacity: 0.5;
          background-color: #4096ef;
        `
      : css`
          opacity: 1;
          background-color: #4096ef;
        `}

  &:hover {
    background-color: #66a9ef;
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  }
  &:active {
    transform: translateY(-1px);
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    background: #4096ef;
  }
`;
export const SecondaryButton = styled(PrimaryButton)`
  background-color: transparent;
  border-color: #707070;
  color: #707070;
  &:hover {
    color: #bfbfbf;
    background-color: transparent;
    border-color: #bfbfbf;
  }
`;
export default PrimaryButton;
